import { type HTMLAttributes, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './DialogBox.module.scss';

export const DialogBox = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={classNames(styles.box, className)} {...props} />
));

DialogBox.displayName = 'DialogBox';
